<div *ngIf="renderData()"></div>
<div #wordcloud [id]="id"></div>
